import { applySpec, defaultTo, join, map, pipe, prop, props } from 'ramda';
import { createSelector } from 'reselect';

export const globalDataSelector = prop('globalData');
export const bankCodesSelector = pipe(globalDataSelector, prop('bankCodes'));
export const bankCodesSelectSelector = createSelector(
  bankCodesSelector,
  pipe(
    defaultTo([]),
    map(
      applySpec({
        value: prop('code'),
        label: pipe(props(['code', 'bankName']), join(' - ')),
        title: prop('code'),
        bankName: prop('bankName'),
      })
    )
  )
);
